import { RotateCcw, Save } from "lucide-react";

export const SelectField = ({ label, value, onChange, options, testId, placeholder = "All" }) => (
  <label className="flex flex-col gap-1">
    <span className="text-[11px] font-semibold uppercase tracking-wider text-slate-500">{label}</span>
    <select
      data-testid={testId}
      value={value ?? ""}
      onChange={(e) => onChange(e.target.value)}
      className="h-8 min-w-[120px] border border-slate-300 bg-white px-2 text-sm text-slate-900 focus:outline-none focus:ring-2 focus:ring-[#1A365D]"
    >
      <option value="">{placeholder}</option>
      {options.map((o) => (
        <option key={String(o)} value={o}>
          {String(o)}
        </option>
      ))}
    </select>
  </label>
);

export const TextField = ({ label, value, onChange, testId, placeholder = "", type = "text" }) => (
  <label className="flex flex-col gap-1">
    <span className="text-[11px] font-semibold uppercase tracking-wider text-slate-500">{label}</span>
    <input
      data-testid={testId}
      type={type}
      value={value ?? ""}
      placeholder={placeholder}
      onChange={(e) => onChange(e.target.value)}
      className="h-8 min-w-[140px] border border-slate-300 bg-white px-2 text-sm text-slate-900 focus:outline-none focus:ring-2 focus:ring-[#1A365D]"
    />
  </label>
);

export const FilterBar = ({ children, onReset, onSave }) => (
  <div className="flex flex-wrap items-end gap-3 border border-slate-200 bg-white p-3">
    {children}
    <div className="ml-auto flex items-end gap-2">
      {onSave && (
        <button
          data-testid="save-search-btn"
          onClick={onSave}
          className="flex h-8 items-center gap-1.5 border border-slate-300 bg-white px-3 text-xs font-semibold text-slate-700 hover:border-[#1A365D] hover:text-[#1A365D]"
        >
          <Save className="h-3.5 w-3.5" /> Save search
        </button>
      )}
      {onReset && (
        <button
          data-testid="reset-filters-btn"
          onClick={onReset}
          className="flex h-8 items-center gap-1.5 border border-slate-300 bg-white px-3 text-xs font-semibold text-slate-700 hover:border-[#1A365D] hover:text-[#1A365D]"
        >
          <RotateCcw className="h-3.5 w-3.5" /> Reset
        </button>
      )}
    </div>
  </div>
);

export const PageHead = ({ title, subtitle, right }) => (
  <div className="flex flex-wrap items-end justify-between gap-3">
    <div>
      <h1 className="font-display text-2xl font-bold tracking-tight text-slate-900">{title}</h1>
      {subtitle && <p className="mt-0.5 text-sm text-slate-500">{subtitle}</p>}
    </div>
    {right}
  </div>
);
